import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EntityLink from '../../../components/modularcomponents/entitylink/entitylink';
import HeaderTitle from '../../../components/modularcomponents/header/headertitle';
import HeaderProperty from '../../../components/modularcomponents/header/headerproperty';
import HeaderPropertyName from '../../../components/modularcomponents/header/headerpropertyname';
import HeaderPropertyValue from '../../../components/modularcomponents/header/headerpropertyvalue';
import { Nullable, PossibleAction, Mandate } from '../../../types/types';
import HeaderRating from '../../../components/headerdata/headerrating';
import HeaderContainer from '../../../components/modularcomponents/header/headercontainer';
import HeaderItems from '../../../components/modularcomponents/header/headeritems';
import HeaderItem from '../../../components/modularcomponents/header/headeritem';
import HeaderSummary from '../../../components/modularcomponents/header/headersummary';
import HeaderAUM from '../../../components/modularcomponents/header/headeraum';
import HeaderButtons from '../../../components/modularcomponents/header/headerbuttons';
import { MandateService } from '../../../services/mandate';

function MandateHeader(props: {entity: Nullable<Mandate>}): ReactElement {
  const { t } = useTranslation();
  const [expand, setExpand] = useState(false);
  const actionList: PossibleAction[] = [];

  const toggleExpand = () => {
    setExpand(val => !val);
  };

  return (
    <>
      { props.entity &&
        <HeaderContainer expanded={expand} setExpanded={setExpand}>
          <HeaderSummary toggleExpand={toggleExpand}>
            <HeaderTitle toggleExpand={toggleExpand} type='mandate' name={props.entity.name} tags={props.entity.tags} />
            <HeaderButtons id={props.entity._id} service={new MandateService()} actionList={actionList} />
          </HeaderSummary>
          <HeaderItems>
            <HeaderItem>
              <HeaderProperty>
                <HeaderAUM aum={props.entity.aum} />
              </HeaderProperty>

              <>
                { props.entity.assetMgr &&
                  <HeaderProperty>
                    <HeaderPropertyName name='Asset Manager ' />
                    <HeaderPropertyValue link>
                      <EntityLink type='assetMgr' id={props.entity.assetMgr._id} name={props.entity.assetMgr.name} openInNewTabIcon/>
                    </HeaderPropertyValue>
                  </HeaderProperty>
                }
              </>

              <>
                { props.entity.investMgr &&
                  <HeaderProperty>
                    <HeaderPropertyName name={`${t('investMgrs.UpperCaseSimpleLabel')} `} />
                    <HeaderPropertyValue link>
                      <EntityLink type='investMgr' id={props.entity.investMgr._id} name={props.entity.investMgr.name} openInNewTabIcon/>
                    </HeaderPropertyValue>
                  </HeaderProperty>
                }
              </>
              <HeaderProperty>
                <HeaderPropertyName name='Strategy ' />
                <HeaderPropertyValue link>
                  <EntityLink type='strategy' id={props.entity.strategy._id} name={props.entity.strategy.name} openInNewTabIcon/>
                </HeaderPropertyValue>
              </HeaderProperty>

              <>
                { props.entity.originalFund &&
                  <HeaderProperty>
                    <HeaderPropertyName name='Original Fund ' />
                    <HeaderPropertyValue link>
                      <EntityLink type='fund' id={props.entity.originalFund._id} name={props.entity.originalFund.name} openInNewTabIcon/>
                    </HeaderPropertyValue>
                  </HeaderProperty>
                }
              </>

              <>
                { props.entity.mandateFund &&
                  <HeaderProperty>
                    <HeaderPropertyName name='Mandate Fund ' />
                    <HeaderPropertyValue link>
                      <EntityLink type='fund' id={props.entity.mandateFund._id} name={props.entity.mandateFund.name} openInNewTabIcon/>
                    </HeaderPropertyValue>
                  </HeaderProperty>
                }
              </>
            </HeaderItem>

            <HeaderItem>
              <HeaderProperty>
                <HeaderPropertyName name='Asset Class ' />
                <HeaderPropertyValue>{props.entity.assetClass}</HeaderPropertyValue>
              </HeaderProperty>

              <HeaderProperty>
                <HeaderPropertyName name='Geography ' />
                <HeaderPropertyValue>{props.entity.geography}</HeaderPropertyValue>
              </HeaderProperty>

              <HeaderProperty>
                <HeaderPropertyName name='Sub Asset Class ' />
                <HeaderPropertyValue>{props.entity.subAssetClass}</HeaderPropertyValue>
              </HeaderProperty>
            </HeaderItem>
            {/* <HeaderProperty>
                <HeaderPropertyName name="Internal code" />
                <HeaderPropertyValue>internal code</HeaderPropertyValue>
              </HeaderProperty>

              <HeaderProperty>
                <HeaderPropertyName name="Open-ended fund" />
                <HeaderPropertyValue>Open-ended fund</HeaderPropertyValue>
              </HeaderProperty>

              <HeaderProperty>
                <HeaderPropertyName name="ISIN Code" />
                <HeaderPropertyValue>LU0851650381</HeaderPropertyValue>
              </HeaderProperty> */}
            <HeaderItem>
              <HeaderRating
                rating={props.entity.ratings}
                nextReviews={props.entity.nextReviews}
                entityType={props.entity.latestDdInfo && !props.entity.latestDdInfo.validationDate ? props.entity.latestDdInfo.type : undefined}
                reviewsStopped={props.entity.hasReviewsStopped}
              />
            </HeaderItem>
          </HeaderItems>
        </HeaderContainer>
      }
    </>
  );
}

export default MandateHeader;
